module.exports = __webpack_public_path__ + "static/media/rocket.12bfe420.svg";